import { render } from "./EnrolleeAddDependantOnboardComponent.vue?vue&type=template&id=00160319&scoped=true"
import script from "./EnrolleeAddDependantOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeAddDependantOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeAddDependantOnboardComponent.vue?vue&type=style&index=0&id=00160319&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00160319"]])

export default __exports__